import React from "react";
import { useTranslate } from "react-admin";
import { Box, Typography } from "@mui/material";
import CreditSummaryOverview from "./CreditSummaryOverview";

/**
 * Credit consumption "Overview". Shows the credit-usage dashboard (KPIs,
 * monthly chart, by-channel and top-cost-centers panels) computed from the
 * live credit event logs plus any archived monthly summary. This is what the
 * Credit consumption → Overview page renders.
 */
export const CreditEventSummaryList: React.FC = () => {
  const translate = useTranslate();
  return (
    <Box>
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, color: "text.primary", mb: 1, mt: 0, ml: 2 }}
      >
        {translate("menu.overview", { _: "Overview" })}
      </Typography>
      <Box sx={{ px: 2 }}>
        <CreditSummaryOverview />
      </Box>
    </Box>
  );
};

export default CreditEventSummaryList;
